import React from "react";

const GridIcon = ({ width = 17, height = 17, fill = "#8126DB", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 17 17`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.166 0.330566H1.83268C0.916016 0.330566 0.166016 1.08057 0.166016 1.99723V15.3306C0.166016 16.2472 0.916016 16.9972 1.83268 16.9972H15.166C16.0827 16.9972 16.8327 16.2472 16.8327 15.3306V1.99723C16.8327 1.08057 16.0827 0.330566 15.166 0.330566ZM5.16602 15.3306H2.66602C2.20768 15.3306 1.83268 14.9556 1.83268 14.4972V11.9972H5.16602V15.3306ZM5.16602 10.3306H1.83268V6.99723H5.16602V10.3306ZM5.16602 5.33057H1.83268V2.83057C1.83268 2.37223 2.20768 1.99723 2.66602 1.99723H5.16602V5.33057ZM10.166 15.3306H6.83268V11.9972H10.166V15.3306ZM10.166 10.3306H6.83268V6.99723H10.166V10.3306ZM10.166 5.33057H6.83268V1.99723H10.166V5.33057ZM14.3327 15.3306H11.8327V11.9972H15.166V14.4972C15.166 14.9556 14.791 15.3306 14.3327 15.3306ZM15.166 10.3306H11.8327V6.99723H15.166V10.3306ZM15.166 5.33057H11.8327V1.99723H14.3327C14.791 1.99723 15.166 2.37223 15.166 2.83057V5.33057Z"
      fill={fill}
    />
  </svg>
);

export default GridIcon;
